import React from 'react';
import * as s from './headerbar.module.css';

import { KeyValue } from "../../types/subTypes";

interface HeaderBarProps {
    items: Array<KeyValue>,
    onClick?: (value: string) => void,
    active: string
};

const HeaderBar: React.FC<HeaderBarProps> = ({
    items,
    onClick,
    active
}) => {

    const HeaderItem = (key: string, value: string) => {
        const style = active === key ? s.itemActive : s.item
        return (
            <span
                key={key}
                className={style}
                onClick={() => onClick ? onClick(key) : {}}
            >
                {value}
            </span>
        );
    };

    return (
        <header
            className={s.header}
        >
            {
                items.map((item: KeyValue) => HeaderItem(item.key, item.value))
            }
        </header>
    );
};

export { HeaderBar };